import React from 'react';
import { Alert, Box, Button, Paper } from '@mui/material';
import GCPBillingFilters from './components/GCPBillingFilters';
import GCPBillingTable from './components/GCPBillingTable';
import ResendInvoiceDialog from './components/ResendInvoiceDialog';
import { useGCPBillingOperations } from './useGCPBillingOperations';

const EMPTY_TEXT = 'No GCP billing data matches the selected filters.';

const GCPBillingOperations = () => {
  const operations = useGCPBillingOperations();

  return (
    <Paper>
      <GCPBillingFilters
        month={operations.filters.month}
        gcpBillingId={operations.filters.gcpBillingId}
        currencies={operations.filters.currencies}
        invoiceFilter={operations.filters.invoiceFilter}
        companyFilter={operations.filters.companyFilter}
        onMonthChange={operations.setMonth}
        onGCPBillingIdChange={operations.setGCPBillingId}
        onCurrenciesChange={operations.setCurrencies}
        onInvoiceFilterChange={operations.setInvoiceFilter}
        onCompanyFilterChange={operations.setCompanyFilter}
      />
      {operations.listError ? (
        <Alert
          sx={{ m: '0 20px 10px' }}
          severity="error"
          action={<Button onClick={operations.retryList}>Retry</Button>}
        >
          {operations.listError}
        </Alert>
      ) : (
        <Box sx={{ mx: 1 }}>
          <GCPBillingTable
            rows={operations.rows}
            total={operations.total}
            loading={operations.loading}
            pagination={operations.pagination}
            resendingId={operations.resendingId}
            emptyText={EMPTY_TEXT}
            onPageChange={operations.setPage}
            onPerPageChange={operations.setPerPage}
            onOpenResend={operations.openResend}
          />
        </Box>
      )}
      <ResendInvoiceDialog
        row={operations.pendingResendRow}
        resendingId={operations.resendingId}
        onClose={operations.closeResend}
        onConfirm={operations.confirmResend}
      />
    </Paper>
  );
};

export default GCPBillingOperations;
